// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Adjustments icon.
 *
 * @component
 * @param {IconProps} props - The IconProps for the AdjustmentsIcon component.
 * @returns {ReactElement} The AdjustmentsIcon component.
 */
export const AdjustmentsIcon = (props: IconProps) => {
  const { color = '#C1C1CF', ...rest } = props;
  return (
    <Icon viewBox='0 0 16 16' color={color} id='adjustments-icon' {...rest}>
      <path
        id='Shape'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.3178 5.40751H10.5908V0.226562H12.3178V1.95355H15.7718V3.68053H12.3178V5.40751ZM0.229492 3.68011V1.95312H8.86441V3.68011H0.229492ZM0.229492 14.0434V12.3164H5.41044V14.0434H0.229492ZM8.86468 15.7669V14.0399H15.7726V12.3129H8.86468V10.5859H7.1377V15.7669H8.86468ZM3.68346 7.13323V5.40625H5.41044V10.5872H3.68346V8.86022H0.229492V7.13323H3.68346ZM15.7726 8.8598V7.13281H7.1377V8.8598H15.7726Z'
        fill='currentColor'
      />
    </Icon>
  );
};
